export default "__VITE_ASSET__DPXgvVi9__"